import { render } from "./VehicleDetails.vue?vue&type=template&id=621fef1c&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"

import "./VehicleDetails.vue?vue&type=style&index=0&id=621fef1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621fef1c"]])

export default __exports__